import * as Sentry from '@sentry/browser';
import ErrorBoundary from '@/components/ErrorBoundary';
import { initSentry } from '@/utils/sentry/index';

if ('serviceWorker' in navigator) {
  // unregister service worker
  const { serviceWorker } = navigator;

  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => {
        sw.unregister();
      });
    });
  }

  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister();
  }); // remove all caches

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (window.caches && (window as any)?.caches?.keys) {
    caches.keys().then((keys) => {
      keys.forEach((key) => {
        caches.delete(key);
      });
    });
  }
}

// 监听并上报全局的 unhandledrejection 事件
window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason, {
    extra: { type: 'unhandledrejection' },
  });
});

// 初始化 Sentry 监控
initSentry();

// 错误组件展示
export const layout = () => {
  return {
    ErrorBoundary: ErrorBoundary,
  };
};

/** 全局非 React 错误捕获 */
window.addEventListener('error', (event) => {
  Sentry?.captureException(event, {
    extra: { type: 'global error catch' },
  });
});
